import { Type } from "class-transformer";
import { GamblingCommitteeSummaryListOutDTO } from "./gambling-committee-summary-list.out.dto";

export class GamblingCommitteePaginatedOutDTO {
  @Type(() => GamblingCommitteeSummaryListOutDTO)
  gamblingCommittees!: GamblingCommitteeSummaryListOutDTO[];

  total!: number;
}
